import { ThisConnector } from '../../../../../api/connector'
import { mapApplication } from '../map-application'
import { ApiApplication } from '../shared'

export interface GetApplicationsArgs {
  organizationUuid?: string
}

export interface GetApplicationsResponse {
  applications: ApiApplication[]
}

export async function getApplications(
  this: ThisConnector,
  { organizationUuid }: GetApplicationsArgs
) {
  const { applications } = await this.connector.get<GetApplicationsResponse>(
    `/${organizationUuid}/applications?expand=skip_links&includeArchived=false&includeMerged=false`
  )
  return applications.map(mapApplication)
}
